import {Observable} from "rxjs";
import {AvailableLandingPageLayouts, DashboardModuleButtonAction, LandingPageSettingsResponse} from "fello-model";

export abstract class AbstractPublicLandingPageService<LPLayoutType extends AvailableLandingPageLayouts> {
  abstract landingPagePublicSetting$: Observable<LandingPageSettingsResponse<LPLayoutType>>;
  abstract performCTAAction(action: DashboardModuleButtonAction, address?: string): Observable<{url: string}>;
  abstract trackView(): Observable<void>;
}
